import React from 'react';
import { useTemplateBoxStyles } from './TemplateBox.styles';
import { IBorder } from './TemplateBox.types';
import cx from 'classnames';
import { IMPORT_URLS } from '../../../Constants/Urls.constants';
import { Button, Dots } from '~/UIKit';

export interface ITemplateBoxProps {
  title: string;
  buttonText: string;
  buttonType: 'downloadTemplate' | 'button';
  border?: IBorder;
  icon?: React.ReactNode;
  description?: string;
  highlight?: boolean;
  loading?: boolean;
  hideButton?: boolean;
}

export const TemplateBox: React.FunctionComponent<ITemplateBoxProps> = ({
  title,
  icon,
  description,
  buttonText,
  border,
  highlight,
  loading,
  buttonType,
  hideButton,
}) => {
  const { classes: templateBoxStyles } = useTemplateBoxStyles({ border })();

  const button = hideButton ? null : (
    <Button type="submit" className={templateBoxStyles.button}>
      {loading ? <Dots color="#fff" /> : buttonText}
    </Button>
  );

  return (
    <div
      className={cx(templateBoxStyles.container, {
        [templateBoxStyles.highlight]: highlight,
      })}
    >
      <div className={templateBoxStyles.title} data-test-id="template-box-title">
        {title}
      </div>
      {icon}
      <div className={templateBoxStyles.description} data-test-id="template-box-description">
        {description}
      </div>
      {buttonType === 'downloadTemplate' && (
        <a
          className={templateBoxStyles.link}
          data-test-id="template-box-button"
          href={IMPORT_URLS.IMPORT_TEMPLATE}
          download="Template.xlsx"
        >
          {button}
        </a>
      )}
      {buttonType === 'button' && button}
    </div>
  );
};
